// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
declare const BRANCH_NAME: any;

const DEPLOY_ENV = getEnvironment();

function getEnvironment() {
  switch (BRANCH_NAME) {
    case 'main':
    case 'new-layouts-test':
      return 'test';
    case 'production':
      return 'prod';
    case 'feature-development':
      return 'feature';
    default:
      return 'dev';
  }
}

export const deployVersion = 'compliance-ux-website-field';

export const assetContracts = {
  'ETH.ETH': {
    address: undefined,
    decimals: 18,
    chainId: '0x1',
  },
  'ETH.USDC': {
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
    chainId: '0x1',
  },
  'ETH.USDT': {
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
    chainId: '0x1',
  },
  'MATIC.USDC': {
    address: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    decimals: 6,
    chainId: '0x89',
  },
  'MATIC.USDT': {
    address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    decimals: 6,
    chainId: '0x89',
  },
  'MATIC.MATIC': {
    address: '0x0000000000000000000000000000000000001010',
    decimals: 18,
    chainId: '0x89',
  },
  'MATIC.POL': {
    address: '0x0000000000000000000000000000000000001010',
    decimals: 18,
    chainId: '0x89',
  },
};

export const testContracts = {
  'ETH.ETH': {
    address: undefined,
    decimals: 18,
  },
  'ETH.USDC': {
    address: '0x64544969ed7EBf5f083679233325356EbE738930',
    decimals: 18,
  },
  'ETH.USDT': {
    address: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
    decimals: 18,
  },
  'MATIC.USDC': {
    address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    decimals: 6,
  },
  'MATIC.USDT': {
    address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    decimals: 6,
  },
};

export const contractABI = [
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: 'guy', type: 'address' },
      { name: 'wad', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: 'src', type: 'address' },
      { name: 'dst', type: 'address' },
      { name: 'wad', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{ name: 'wad', type: 'uint256' }],
    name: 'withdraw',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [{ name: '', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', type: 'string' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: 'dst', type: 'address' },
      { name: 'wad', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', type: 'bool' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'deposit',
    outputs: [],
    payable: true,
    stateMutability: 'payable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      { name: '', type: 'address' },
      { name: '', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  { payable: true, stateMutability: 'payable', type: 'fallback' },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'src', type: 'address' },
      { indexed: true, name: 'guy', type: 'address' },
      { indexed: false, name: 'wad', type: 'uint256' },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'src', type: 'address' },
      { indexed: true, name: 'dst', type: 'address' },
      { indexed: false, name: 'wad', type: 'uint256' },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'dst', type: 'address' },
      { indexed: false, name: 'wad', type: 'uint256' },
    ],
    name: 'Deposit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'src', type: 'address' },
      { indexed: false, name: 'wad', type: 'uint256' },
    ],
    name: 'Withdrawal',
    type: 'event',
  },
];

export const DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

export const devEnvironment = DEPLOY_ENV === 'dev';

export const testEnvironment = DEPLOY_ENV === 'test';

// this decimalPlacesFor value is set in fetchDecimalPlaces
// export let decimalPlacesFor:{ [assetTicker: string]: number } = {};

export const currentFiats = ['USD.USD', 'EUR.EUR', 'BRL.BRL'];

export const systemLanguages = [
  { language: 'en', name: 'English' },
  { language: 'pt-br', name: 'Português' },
  { language: 'es', name: 'Español' },
];

if (getEnvironment() == 'dev') {
  systemLanguages.push(
    { language: 'he', name: 'Hebrew' },
    { language: 'hi', name: 'Hindi' },
    { language: 'zh-Hans', name: 'Chinese' },
    { language: 'ar', name: 'Arabic' },
    { language: 'da', name: 'Danish' },
    { language: 'nl', name: 'Dutch' },
  );
}

export const systemSupportedNetworks = ['ETH', 'BTC', 'MATIC', 'TRC'];

export const minutes = 15;

export const polygon = 'MATIC';

export const binance = 'BEP';

export const qrApi: string = 'https://quickchart.io/chart?cht=qr&chs=300x300&chl=';

export const secondaryQrApi: string =
  'https://qrcode.tec-it.com/API/QRCode?size=Small&quietzone=50&quietunit=Px&&data=';

export const ipGeoLocationApi: string = 'https://api.ipgeolocation.io/ipgeo?apiKey=';
export const ipGeoLocationApiKey: string = '92634ec661fe4131a262f271da9e533b';

export const flagsApi = 'https://flagcdn.com/en/codes.json';

export const ethAddress: string = 'https://etherscan.io/';
export const btcAddress: string = 'https://btcscan.org/';
export const polyAddress: string = 'https://polygonscan.com/';
export const tronScan: string = 'https://tronscan.org/#';
export const bnbAddress: string = 'https://bscscan.com/';

export const tronApiValidateAddress: string = 'https://api.shasta.trongrid.io/wallet/validateaddress';

export const translatedWebsiteLink =
  '.translate.goog{{websitePath}}/?_x_tr_sl=en&_x_tr_tl={{targetLanguage}}&_x_tr_hl={{targetLanguage}}&_x_tr_pto=wapp';

export const environment = {
  production: DEPLOY_ENV === 'prod' ? true : false,
  apiPublic: (() => {
    if (DEPLOY_ENV === 'dev') {
      return 'https://api-public.dev.pay.nicky.me/swagger/index.html';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://api-public.test.pay.nicky.me/swagger/index.html';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://api-public.pay.nicky.me/swagger/index.html';
    } else if (DEPLOY_ENV === 'feature') {
      return 'https://nicky-feature-api.azurewebsites.net/swagger/index.html';
    }
    return '';
  })(),
  api: (() => {
    if (DEPLOY_ENV === 'dev') {
      return 'https://nicky-dev-api.azurewebsites.net/';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://nicky-test-api.azurewebsites.net/';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://api.pay.nicky.me/';
    } else if (DEPLOY_ENV === 'feature') {
      return 'https://nicky-feature-api.azurewebsites.net/';
    }
    return '';
  })(),
  auth0ID: (() => {
    if (DEPLOY_ENV === 'dev' || DEPLOY_ENV === 'feature') {
      return 'SqrJq2fxJ6adrOFaR24oh9COF4vZwqba';
    } else if (DEPLOY_ENV === 'test') {
      return 'T61de0bgzUuXU0A5zS8dHPqIjornDVyR';
    } else if (DEPLOY_ENV === 'prod') {
      return 'RtHDnh262zmYy8GGNxIpNDTj0xjcmPco';
    }
    return '';
  })(),
  auth0Domain: (() => {
    if (DEPLOY_ENV === 'dev' || DEPLOY_ENV === 'feature') {
      return 'https://dev-eq0ptfwdhb1s1h12.us.auth0.com';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://nicky-test.us.auth0.com';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://nicky-prod.us.auth0.com';
    }
    return '';
  })(),
  auth0Audience: (() => {
    if (DEPLOY_ENV === 'dev' || DEPLOY_ENV === 'feature') {
      return 'https://nicky-tech.azurewebsites.net';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://nicky-test.azurewebsites.net';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://nicky-prod.azurewebsites.net';
    }
    return '';
  })(),
  mouseFlow: (() => {
    if (DEPLOY_ENV === 'dev' || DEPLOY_ENV === 'feature') {
      return '//cdn.mouseflow.com/projects/08118b65-8f70-484b-8d2d-bdf69893cbdd.js';
    } else if (DEPLOY_ENV === 'test') {
      return '//cdn.mouseflow.com/projects/19523c18-1681-45c3-8542-79100f65c774.js';
    } else if (DEPLOY_ENV === 'prod') {
      return '//cdn.mouseflow.com/projects/19523c18-1681-45c3-8542-79100f65c774.js';
    }
    return '';
  })(),
  environmentUrl: (() => {
    if (DEPLOY_ENV === 'dev') {
      return 'https://dev.pay.nicky.me';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://test.pay.nicky.me';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://pay.nicky.me';
    } else if (DEPLOY_ENV === 'feature') {
      return 'https://featuredev.pay.nicky.me/';
    }
    return '';
  })(),
  websiteUrl: (() => {
    if (DEPLOY_ENV === 'dev' || DEPLOY_ENV === 'feature') {
      return 'https://dev.nicky.me';
    } else if (DEPLOY_ENV === 'test') {
      return 'https://test.nicky.me';
    } else if (DEPLOY_ENV === 'prod') {
      return 'https://nicky.me';
    }
    return '';
  })(),
  recaptcha: '6LcH81YmAAAAAASfdARBBLvtJDQMwHJ3XDmesl7d',
  blockchainExplorers: {
    ETH: {
      baseUrl: 'https://etherscan.io/',
      txPath: 'tx',
    },
    MATIC: {
      baseUrl: 'https://polygonscan.com/',
      txPath: 'tx',
    },
    BTC: {
      baseUrl: 'https://btcscan.org/',
      txPath: 'tx',
    },
    BEP: {
      baseUrl: 'https://bscscan.com/',
      txPath: 'tx',
    },
    TRC: {
      baseUrl: 'https://tronscan.org/#/',
      txPath: 'transaction',
    },
  } as const,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
